// extracted by mini-css-extract-plugin
export default {"box":"minicart_box__R1lpG","removebtn":"minicart_removebtn__gk7eN"};